import { seoConfig } from '@shared/configs';
import { buildFilterPagePath, extendBreadcrumbsWithSlug } from '@shared/ui/breadcrumbs';

import { NewsApi } from '@entities/news';

import { NEWS_PER_PAGE } from '@pages/news';

import type { PageLoad } from './$types';

export const load: PageLoad = async ({ fetch, data }) => {
  const { loadMore, page } = data;

  const newsApi = new NewsApi(fetch);

  const perPage = NEWS_PER_PAGE;
  const perPageMultiplier = loadMore ? +loadMore + 1 : 1;

  const newsRequest = new URLSearchParams({
    limit: String(perPage * perPageMultiplier),
    offset: String((page - 1) * perPage),
    column: 'custom_publication_date',
    order: 'desc',
  });

  const news = await newsApi.readMany(newsRequest);

  const extraPath = buildFilterPagePath({ baseUrl: '/news/', page });

  const baseBreadcrumbs = [
    {
      name: 'Home',
      slug: '/',
      canonical: false,
    },
    {
      name: 'News',
      slug: '/news/',
      canonical: !extraPath,
    },
  ];

  const breadcrumbs = extendBreadcrumbsWithSlug({
    baseBreadcrumbs,
    slug: extraPath,
    name: `Page ${page}`,
  });

  const seo = seoConfig.news({
    breadcrumbs,
  });

  return {
    news: news.data,
    totalCount: news.total_count,
    seo,
    page,
    loadMore,
  };
};
